import moment from 'moment';
import { memo, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Col, Form, Row } from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import { useClickAway } from 'react-use';
import {
  getDragDropStyle,
  isHiddenInPrint,
  itemTitleStyle,
  itemSettingStyle,
  lineHeightStyle,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';
import SelectedItemSearch from './selectedItemSearch';
import { useSelector } from 'react-redux';

const TreatmentPlan = ({
  element,
  prescriptionItems,
  setIsTreatmentPlanModal,
  deletePrescriptionItem,
  selectedTreatmentPlans,
  setSelectedTreatmentPlans,
  isHistoryPage = false,
  isDelBtn = true,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const [isEdit, setIsEdit] = useState('');

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = reorder(
      selectedTreatmentPlans,
      result.source.index,
      result.destination.index,
    );
    setSelectedTreatmentPlans(reorderedItems);
  };

  // this function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleExtras = (item, fieldName, val) => {
    const objIndex = selectedTreatmentPlans.findIndex(
      (complain) => complain.name === item.name,
    );
    selectedTreatmentPlans[objIndex][fieldName] = val;
    setSelectedTreatmentPlans([...selectedTreatmentPlans]);
  };

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsEdit('');
  });

  const editMode = (item) => {
    return (
      <Row ref={ref} className="selected-row-edit" key={item.name}>
        <Col className="name pl-0 pr-0" lg="4" md="4" sm="12" xs="12">
          <SelectedItemSearch
            apiUrl="treatment-plans"
            selectedItemName={item.name}
            selectedItems={selectedTreatmentPlans}
            selectedItemsAction={setSelectedTreatmentPlans}
          />
        </Col>
        <Col lg="3" md="3" sm="12" xs="12" className="responsive">
          <Form.Control
            type="date"
            size="sm"
            placeholder="Enter duration"
            defaultValue={item.date}
            onChange={(e) => handleExtras(item, 'date', e.target.value)}
          />
        </Col>
        <Col lg="4" md="4" sm="12" xs="12" className="responsive pl-0 pr-0">
          <TextareaAutosize
            minRows={1}
            maxRows={3}
            defaultValue={item?.note}
            className="text-editor-edit"
            onChange={(e) => handleExtras(item, 'note', e.target.value)}
          />
        </Col>
        <Col md="1" className="text-right pr-0">
          <i
            className="fa fa-times-circle pt-2"
            aria-hidden="true"
            onClick={() => setIsEdit('')}
          ></i>
        </Col>
      </Row>
    );
  };

  return (
    <div
      className={`row item-row ${
        selectedTreatmentPlans?.length ? 'data-item' : 'no-data-item'
      }`}
      key={`treatment-plan`}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'treatment-plan')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['treatment-plan']?.titleStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setIsTreatmentPlanModal(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Treatment Plan</span>
        )}
      </span>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <ul
              className="sub-child-list drag-drop"
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={lineHeightStyle('treatment-plan', prescriptionItems)}
            >
              {selectedTreatmentPlans?.map((item, index) => (
                <Draggable
                  key={item.name}
                  draggableId={item.name}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <li
                      key={index}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...getDragDropStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        ),
                        position: 'relative',
                      }}
                    >
                      <div onClick={() => setIsEdit(index)}>
                        <span
                          className="text-left pr-5"
                          style={itemSettingStyle(
                            prescriptionItems?.items?.['treatment-plan']
                              ?.itemStyle || {},
                          )}
                        >
                          {item.name}{' '}
                          {item.date !== ''
                            ? '- ' + moment(item.date).format('DD-MM-YYYY')
                            : ''}
                        </span>
                        {!isHistoryPage && (
                          <CommonDeleteBtn
                            action={deletePrescriptionItem}
                            itemName={'treatmentPlan'}
                            delId={item.name}
                          />
                        )}
                      </div>
                      {item.note !== '' ? (
                        <div
                          style={itemSettingStyle(
                            prescriptionItems?.items?.['treatment-plan']
                              ?.subItemStyle || {},
                          )}
                          className="pl-2 font-italic"
                        >
                          - {item.note}
                        </div>
                      ) : (
                        ''
                      )}
                      {index === isEdit && editMode(item)}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default memo(TreatmentPlan);
